export default "__VITE_ASSET__491fa9a3__"